/* eslint-disable max-len */
/* eslint-disable no-lonely-if */
/* eslint-disable camelcase */
/* eslint-disable prefer-template */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-console */
/* eslint-disable func-names */
/* eslint-disable no-undef */

if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
    $(document).ready(() => {
        window.mdc.autoInit();
        // eslint-disable-next-line no-unused-vars
        initButtons();
        const myLazyLoad = new LazyLoad();
        myLazyLoad.update();
        picturefill();
        $('[data-toggle="tooltip"]').tooltip();
        toastr.options = {
            closeButton: true,
            debug: false,
            newestOnTop: false,
            progressBar: true,
            positionClass: 'toast-top-right',
            preventDuplicates: false,
            onclick: null,
            showDuration: '500',
            hideDuration: '500',
            timeOut: '5000',
            extendedTimeOut: '5000',
            showEasing: 'swing',
            hideEasing: 'linear',
            showMethod: 'fadeIn',
            hideMethod: 'fadeOut',
        };
        // $("input[type='number'].number-selector").inputSpinner();
    
        const localStorageBookmarkItems = JSON.parse(localStorage.getItem('bookmark_list'));
        if (localStorageBookmarkItems && localStorageBookmarkItems.length) {
            $('.navigation-icon__web--bookmarks').addClass('navigation-icon__web--active');
            $('.navigation-icon__web--bookmarks').html('star');
            $('.navigation-icon__mobile--bookmarks').html('star');
        } else {
            $('.navigation-icon__web--bookmarks').html('star_border');
            $('.navigation-icon__mobile--bookmarks').html('star_border');
        }
    
        const localStorageCompareItems = JSON.parse(localStorage.getItem('compare_list'));
        if (localStorageCompareItems && localStorageCompareItems.length) {
            $('.navigation-icon__web--compare').addClass('navigation-icon__web--active');
        }
    });
    
    function initButtons() {
        const buttons = document.querySelectorAll('.mdc-button');
        buttons.forEach((button) => mdc.ripple.MDCRipple.attachTo(button));
        const fabs = document.querySelectorAll('.mdc-fab');
        fabs.forEach((fab) => mdc.ripple.MDCRipple.attachTo(fab));
        const sliders = document.querySelectorAll('.mdc-slider');
        sliders.forEach((slider) => mdc.slider.MDCSlider.attachTo(slider));
        // const dropDowns = document.querySelectorAll('.mdc-select');
        // dropDowns.forEach((dropDown) => mdc.select.MDCSelect.attachTo(dropDown));
        const textFields = document.querySelectorAll('.mdc-text-field');
        textFields.forEach((textField) => mdc.textField.MDCTextField.attachTo(textField));
        const switchControls = document.querySelectorAll('.mdc-switch');
        switchControls.forEach((switchControl) => mdc.switchControl.MDCSwitch.attachTo(switchControl));
    }
    
    jQuery.urlParam = function (name) {
        const results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.search);
        return (results !== null) ? results[1] || 0 : false;
    };
}
